import TopBar from "./TopBar";
import BottomNav from "./BottomNav";
import { useAuth } from "../context/AuthContext";

export default function AppLayout({ children }) {
    const { user } = useAuth();
    return (
        <div className="min-h-screen bg-background text-foreground flex flex-col">
            <TopBar />
            <main className="flex-1 pb-20 md:pb-8 page-fade-in">
                {children}
            </main>
            {user && <BottomNav />}
        </div>
    );
}
